/**
 * @generated SignedSource<<6a9b624843b528c318a9500e747839f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_issueResults$data = {
  readonly isCappingIssueSearchResult: boolean | null | undefined;
  readonly issueSearchError: {
    readonly __typename: "JiraServerError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly pageInfo?: {
    readonly hasPreviousPage: boolean;
  };
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationsWrapper" | "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults" | "main_issueNavigator_FullPageIssueApp_issueResults" | "main_issueNavigator_Header_issueResults" | "main_issueNavigator_IssueResults_issueResults" | "topBar_issueNavigator_issueResults">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_issueResults";
};
export type main_issueNavigator_IssueNavigatorUI_issueResults$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_FullPageIssueApp_issueResults"
    },
    {
      "kind": "LinkedField",
      "name": "issueSearchError",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ],
          "type": "JiraServerError"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    },
    {
      "kind": "ScalarField",
      "name": "isCappingIssueSearchResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "BulkOperationsWrapper"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "85354c37c3da7037561e059e60c3b925";

export default node;
